// extracted by mini-css-extract-plugin
export default {"clickable":"styles-module__clickable__src-labstep-web-core-Collapsible-_sSsMU"};